<template>
	<div class="auth password-request">
		<h1>{{ $t('base.auth.request_new_password') }}</h1>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<div v-if="success">
				<div class="alert alert-success">{{ success }}</div>
				<router-link class="btn btn-primary" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.login') }}</router-link>
			</div>
			<div class="auth-pr" v-if="!success">
				<input-text v-model="model.email" name="email" placeholder="Email" rules="required|email"/>
				<div class="form-group form-group--inline">
					<router-link class="btn btn-round" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.back') }}</router-link>
					<button class="btn btn-primary btn-round" type="submit">{{ $t('base.auth.request') }}</button>
				</div>
			</div>
			<error-box v-if="error" :error="error"/>
		</form>
	</div>
</template>

<script>
export default {
	data () {
		return {
			model: {
				email: ''
			},
			email: '',
			success: '',
			error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.success = ''
			this.error = ''
			this.$api.auth.passwordRequest(this, this.model).then(response => {
				this.$log.info('user password request', 'auth.passwordRequest OK', response)()
				this.success = response.body.message
			}).catch(errors => {
				this.$log.error('user password request', 'auth.passwordRequest ERROR', errors)()
				this.error = errors
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.request_new_password'))
	}
}
</script>

<style scoped>
.auth-pr {
	width: 100%;
}

.auth > h1 {
	color: #000;
	border-bottom: 1px solid black;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/AuthPasswordRequest.vue